import { useSelector } from "react-redux";
import { RequestState } from "../types/types";

export const useRequest = () => {
    return useSelector((state: RequestState) => state.request);
};
